import axios from "../config/axios-kb"


export const OrganizationRepository = {
  getAll: () => {
    return axios.get(`/api/organization`);
  },
  getUserOrganizations: (username) => {
    return axios.get(`/api/organization-member/${username}/organizations`);
  },
  delete: (id) => {
    return axios.delete(`/api/organization/${id}`)
  },
  create: (organization) => {
    return axios.post('/api/organization', organization)
  },
  edit: (id, organization) => {
    return axios.put(`/api/organization/${id}`, organization)
  },
  publish: (id) => {
    return axios.patch(`/api/organization/${id}/publish`)
  },
  getEntities: (organizationId) => axios.get(`/api/organization/${organizationId}/entities`),
  getRelations: (organizationId) => axios.get(`/api/organization/${organizationId}/relations`),
}